import getters from './live-stats.getters'
import actions from './live-stats.actions'

export default {
  namespaced: true,
  actions,
  getters,
}
